import { FC } from 'react';
import { Marker } from 'react-map-gl';

import classes from './user-position-marker.module.css';

interface UserPositionMarkerProps {
  latitude: number;
  longitude: number;
}

export const UserPositionMarker: FC<UserPositionMarkerProps> = ({
  latitude,
  longitude,
}) => (
  <Marker anchor="center" latitude={latitude} longitude={longitude}>
    <div className={classes.marker} />
  </Marker>
);
